import React, { useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { clearSignupProgress } from '../utils/signupProgress';

function ThankYouPage() {
  // Clear signup progress when thank you page loads (signup is complete)
  useEffect(() => {
    clearSignupProgress();
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
        px: 2
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center' }}>
          {/* Logo */}
          <Box sx={{ mb: 6 }}>
            <img
              src="/icob-bhd.png"
              alt="Boost Health Daily"
              style={{ 
                maxWidth: '200px', 
                height: 'auto',
                margin: '0 auto'
              }}
            />
          </Box>

          {/* Thank You Message */}
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              color: '#000000',
              lineHeight: 1.4,
              mb: 4,
              textAlign: 'center'
            }}
          >
            Thank you for
            <br />
            applying if you are
            <br />
            selected to create
            <br />
            content with us we
            <br />
            will email you.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default ThankYouPage;

